import React from 'react'

import { useSaveGroup } from './_requests/saveGroup'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import { useGroup } from './_load/GroupLoader'

const EditGroupForm = () => {
  const group = useGroup()
  const [onSubmit, { loading, error }] = useSaveGroup()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={group || {}}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditGroupForm
